import React from 'react';
//Material UI
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import CircularProgress from '@mui/material/CircularProgress'

//Components
import Modal from '../index'

const Transition = React.forwardRef(function Transition (props, ref) {
    return <Zoom ref={ref} {...props} />;
});

const ModalManualInvoice = ({ open, maxWidthModal, title, message, onAccept, onCancel, onClose, onManual, loading }) =>
    <Modal 
        title={title}
        maxWidth={maxWidthModal || "xs"}
        disableEscapeKeyDown
        open={open}
        onClose={onClose}
        fullScreen={false}
        fullWidth={false}
        TransitionComponent={Transition}
    >
        <Grid container direction='column' spacing={2}>
            <Grid size="grow">
                <Typography variant="body1">
                    {message}
                </Typography>
            </Grid>
            <Grid size="grow">
                {
                    loading &&
                    <Grid container justifyContent='center'>
                        <CircularProgress />
                    </Grid>
                }
                {
                    !loading &&
                    <Grid container justifyContent='space-between'>
                        {   onManual &&
                            <Button 
                                style={{ width:'25%' }}
                                onClick={onManual} 
                                color="primary" 
                                variant="text"
                            >
                                Manual
                            </Button>
                        }
                        <Button 
                            style={{ width:'25%' }}
                            onClick={onCancel} 
                            color="primary"
                            variant='outlined' 
                            autoFocus
                        >
                            No
                        </Button>
                        <Button 
                            style={{ width:'25%' }}
                            onClick={onAccept} 
                            color="primary" 
                            variant="contained"
                        >
                            Si
                        </Button>
                    </Grid> 
                }
            </Grid>
        </Grid>
    </Modal>

export default ModalManualInvoice;